import { toast } from 'react-toastify'
import { io } from 'socket.io-client'
import RootStore from '../store/RootStore'
import { Place } from '../types/models/Place'

const placeVlaue = localStorage.getItem('place')
let connectionCount = 0
let timer: any

export const socket = io({
  query: {
    placesId: placeVlaue,
  },
  transports: ['websocket'],
})

socket.on('login', (data: any) => {
  function somefun() {
    if (timer) {
      clearTimeout(timer)
      timer = setTimer()
    }
  }
  const setTimer = () => {
    return setTimeout(() => {
      RootStore.authStore.logout()
    }, 30000)
  }
  clearTimeout(timer)
  timer = setTimer()

  document.addEventListener('click', somefun)

  RootStore.authStore.saveToken(data, true)
})

socket.on('initPlace', (data: Place) => {
  RootStore.settingsStore.clientId = socket.id

  if (data !== null && data !== undefined)  {
    RootStore.settingsStore.ip = data.ip
  
    if (data.locationId) {
      RootStore.settingsStore.locationId = data.locationId
      localStorage.setItem('locationId', data.locationId)
    } else {
      localStorage.removeItem('locationId')
    }
    if (data.location) {
      RootStore.settingsStore.location = data.location
      localStorage.setItem('location', data.location.name)
    } else {
      localStorage.removeItem('location')
    }
  }
})

socket.on('loginFalse', (data: { key: string }) => {
  console.log(`loginFalse`, data)
  RootStore.authStore.logout()
  toast.error('Ключ не распознан')
  RootStore.modalsUi.hundleSetAddKeyToUser(data.key)
})

socket.on('connect_error', () => {
  connectionCount++
  toast.error(`Переподключение к серверу... ${connectionCount}`, {})
  setTimeout(() => {
    socket.connect()
  }, 5000)
})

socket.on('connect', () => {
  if (connectionCount) {
    toast.success('Соединение восстановлено')
    connectionCount = 1
  }
})

socket.on('restart', () => {
  window.location.reload()
})
